import { ReactComponent as Hauptinsel } from "../../assets/svg/Hauptinsel.svg";
import { ReactComponent as HausanschlussBusiness } from "../../assets/svg/HausanschlussBusiness.svg";
import { ReactComponent as RechtUndTechnik } from "../../assets/svg/RechtUndTechnik.svg";
import { ReactComponent as ErzeugungsanlagenBusiness } from "../../assets/svg/ErzeugungsanlagenBusiness.svg";
import { ReactComponent as EMobilitaet } from "../../assets/svg/E-Mobilitaet.svg";
import { ReactComponent as OnlineServices } from "../../assets/svg/OnlineServices.svg";
import { ReactComponent as Netzauskunft } from "../../assets/svg/Netzauskunft.svg";
import { ReactComponent as KabelZaehler } from "../../assets/svg/Kabel/Kabel-Zaehler.svg";
import { ReactComponent as KabelHausanschluss } from "../../assets/svg/Kabel/Kabel-Hausanschluss.svg";
import { ReactComponent as KabelOnlineServices } from "../../assets/svg/Kabel/Kabel-Online-Services.svg";
import { ReactComponent as KabelNetzgebietspruefung} from "../../assets/svg/Kabel/Kabel-Netzgebietspruefung.svg";
import { ReactComponent as KabelEMobilitaet} from "../../assets/svg/Kabel/Kabel-EMobilitaet.svg";
import { ReactComponent as KabelErzeugungsanlagen} from "../../assets/svg/Kabel/Kabel-Erzeugungsanlagen.svg";
import { RedDot } from "../../assets/svg/Kabel/reddot"
import { Headline } from "../../assets/headline/headline"
import {modules} from '../Overworld'
import {popups} from '../Overworld'
import '../../assets/svg/Kabel/animationKabel.scss'
import '../../assets/svg/animationSVG/animationErzeugungsanlagen.scss'
import '../../assets/svg/animationSVG/animationZaehler.scss'
import '../../assets/svg/animationSVG/animationNetzauskunft.scss'
import '../../assets/svg/animationSVG/animationEmobilitaet.scss'
import '../../assets/svg/animationSVG/animationHausanschluss.scss'
import '../../assets/svg/animationSVG/animationOnlineServices.scss'
import '../../assets/svg/animationSVG/animationRechtUndTechnik.scss'

//Dies ist der Hauptbestandteil der GNO. Die overworld-Map wird hier aus den einzelnen Inseln zusammengesetzt und als SVG exportiert

export function MapBusiness(props: { switchToModule: Function; openPopup: Function }) {

    return (
      <svg id ="gno-overworld-svg" width="100%" height="100%" viewBox="0 0 1661 1250">
        <g>
          {/*NETZAUSKUNFT: Enthält: 
          1. Allgemeine Gruppe 
          2. Klickbare Gruppe
          3. Illustration
          4. Kabel-Illustartion mit animierten Punkten
          5. Headline in Buttonform
          (Alle Bestandteile der Map sind so aufgebaut, können aber in der Reihenfolge variieren) */}
          <g transform="translate(580,50)">
          <g transform="translate(195,170)">
                <KabelNetzgebietspruefung/>
                <g className="reddotNetzauskunft"><RedDot/></g>
                <g className="reddotNetzauskunft Delay2"><RedDot/></g>
              </g>
            <g id="gno-island"  
              onClick={() => props.openPopup(popups.NETZAUSKUNFTBUSINESS)}
              data-testid="netzauskunft"
            >
              <Netzauskunft id="gno-overworld-item"/>
              <g transform="translate(55,220)" id="gno-overworld-item">
                <Headline label="Netzauskunft" />
              </g>
            </g>
          </g>

          {/*ERZEUGUNGSANLAGEN*/}
          <g transform="translate(1125,540)">
            <g transform="translate(-100,60)">
              <KabelErzeugungsanlagen/>
              <g className="reddotErzeugungsanlagen"><RedDot/></g>     
              <g className="reddotErzeugungsanlagen Delay2"><RedDot/></g>
            </g>
            <g id="gno-island"
              onClick={() => props.switchToModule(modules.ERZEUGUNGSANLAGENBUSINESS)}
              data-testid="erzeugungsanlagen"
            >
              <ErzeugungsanlagenBusiness id="gno-overworld-item"/>
              <g transform="translate(55,350)" id="gno-overworld-item">
                <Headline label="Erzeugungsanlagen" />
              </g>
            </g>
          </g>

          {/*E-MOBILITAET*/}
          <g transform="translate(1120,250)">
            <g id="gno-island"
              onClick={() => props.openPopup(popups.ELEKTROMOBILITAETBUSINESS)} 
              data-testid="emobilitaet" 
            >
              <EMobilitaet id="gno-overworld-item" />
              <g transform="translate(55,212)" id="gno-overworld-item">
                <Headline label="E-Mobilität" />
              </g>
            </g>
            <g transform="translate(-105,163)">
              <KabelEMobilitaet/>
              <g className="reddotEMobilitaet"><RedDot/></g>
              <g className="reddotEMobilitaet Delay2"><RedDot/></g>
            </g>
          </g>

          {/*ONLINE-SERVICES*/}
          <g transform="translate(75,170)">
            <g id="gno-island"
              onClick={() => props.openPopup(popups.ONLINESERVICES)}
              data-testid="onlineservices" 
            >
              <OnlineServices id="gno-overworld-item" />
              <g transform="translate(55,295)" id="gno-overworld-item">
                <Headline label="Online-Services" />
              </g>
            </g>
            <g transform="translate(443,250)">
              <KabelOnlineServices/>
              <g className="reddotOnlineService"><RedDot/></g>
              <g className="reddotOnlineService Delay2"><RedDot/></g>
            </g>
          </g>
          
         {/*RECHT UND TECHNIK*/}
         <g transform="translate(580,852)">
            <g transform="translate(280,-110)">
              <KabelZaehler/>
              <g className="reddotZaehler"><RedDot/></g>
              <g className="reddotZaehler Delay2"><RedDot/></g>
            </g>
            <g id="gno-island"
              onClick={() => props.switchToModule(modules.RECHTUNDTECHNIK)}
              data-testid="zaehler" 
            >
              <RechtUndTechnik id="gno-overworld-item" />
              <g id="gno-overworld-item" transform="translate(55,264)">
                <Headline label="Recht & Technik" />
              </g>
            </g>
          </g>
  
        {/*HAUPTINSEL*/}
        <g id="gno-island" 
          transform="translate(607,368)"
          onClick={() => props.openPopup(popups.HAUPTINSEL)}      
          data-testid="hauptinsel" 
         >
          <Hauptinsel id="gno-overworld-item"  />
          {<g transform="translate(54,330)" id="gno-overworld-item">
            <g> <Headline label="N-ERGIE Netz" /> </g>
          </g>}
        </g>

          {/*HAUSANSCHLUSS Geschäftskunden*/}
          <g transform="translate(65,624)">  
            <g id="gno-island"
              onClick={() => props.switchToModule(modules.HAUSANSCHLUSSBUSINESS)}
              data-testid="hausanschluss" 
            >
              <HausanschlussBusiness id="gno-overworld-item" />
              <g transform="translate(55,245)" id="gno-overworld-item">
                <Headline label="Anschluss" />
              </g>
            </g>
            <g transform="translate(446,76)">
              <KabelHausanschluss/>
              <g className="reddotHausanschluss"><RedDot/></g>
              <g className="reddotHausanschluss Delay2"><RedDot/></g>
            </g>
          </g>
        </g>
      </svg>
    );
  }